import React, { useEffect, useState } from "react";
import Content from "../../../Components/Dashboard/Content/Content";
import { Link } from "react-router-dom";
import Loader from "../../../Utils/Loader";
import { FolderLock, Plus, FileClock, Users2, RadioTower } from "lucide-react";
// import FullDataTable from "../../../Components/ExtraComponents/Datatable/FullDataTable";
import Table from "../../../Components/ExtraComponents/Tables/FullDataTable";

import { All_Panel_List } from "../../../ReduxStore/Slice/Superadmin/SuperAdminSlice";
import { useDispatch } from "react-redux";
import ToastButton from "../../../Components/ExtraComponents/Alert_Toast";
import SidebarPermission from "./Sidebar_permission";
import AddLicence from "./Add_Licence";
import Adjust_Month from "./Adjust_Month";
import LicenceDetails from "./LicenceDetails";
import BrokerPermittion from "./Broker_Permittion";
import Modal from "../../../Components/ExtraComponents/Modal";
import { Get_Panel_History } from "../../../ReduxStore/Slice/Superadmin/SuperAdminSlice";

const AllPermitions = () => {
  const dispatch = useDispatch();
  const [filteredData1, setFilteredData1] = useState([]);
  const [showModal, setshowModal] = useState(false);
  const [showAddLicenceModal, setshowAddLicenceModal] = useState(false);
  const [showAdjustMonthModal, setshowAdjustMonthModal] = useState(false);
  const [showPanelName, setshowPanelName] = useState(false);
  const [showLicenceModal, setshowLicenceModal] = useState(false);
  const [showLicenceDetails, setshowLicenceDetails] = useState({});
  const [showBrokerModal, setshowBrokerModal] = useState(false);
  const [showBrokerDetails, setshowBrokerDetails] = useState("");
  const [HistoryStatus, SetHistoryStatus] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [panelData, setPanelData] = useState({ loading: true, data: [] });
  const [panelData1, setPanelData1] = useState({ loading: true, data: [] });
  const [refresh, setRefresh] = useState(false);

  const data = async () => {
    await dispatch(All_Panel_List())
    
      .unwrap()
      .then((response) => {
        if (response.status) {
          setPanelData1({
            loading: false,
            data: response.data,
          });

          setPanelData({
            loading: false,
            data: response.data,
          });
        } else {
          setPanelData({
            loading: false,
            data: [],
          });
          setPanelData1({
            loading: false,
            data: [],
          });
        }
      })
      .catch((err) => {
        return;
      });
  };

  const Panel_Info = async (row) => {
    setshowLicenceDetails({
      id: row._id,
      db_url: row.backend_rul,
      db_name: row.db_name,
    });
    setshowLicenceModal(true);
  };

  const Panel_History = async (row) => {
    const response = await dispatch(Get_Panel_History()).unwrap();
    if (response.status) {
      var FilterData = response.data.filter(
        (data) => data.panal_name === row.panel_name
      );
    
      setFilteredData1(FilterData);
      SetHistoryStatus(true);
    } else {
    }
  };

  const setLocalStorage = (row) => {
    localStorage.setItem("RowData", row._id);
    localStorage.setItem("backend_rul", row.backend_rul);
    localStorage.setItem("panel_name", row.panel_name);
  };

  const handleLocalStorage = (row) => {
    localStorage.setItem("backend_rul", row.backend_rul);
    localStorage.setItem("panel_name", row.panel_name);
  };

  const columns = [
    {
      name: "Panel Name",
      selector: (row) => row.panel_name,
      cell: (row) => (
        <span title="Panel Views">
          <Link
            to={`${row.domain}/#/login`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none", // removes underline
              filter: "blur(0)", // ensures no blur
            }}
          >
            {row.panel_name}
          </Link>
        </span>
      ),
      sortable: true,
    },
    {
      name: "Broke permission",
      cell: (row) => (
        <span
          data-toggle="tooltip"
          data-placement="top"
          title="Sidebar Permission"
        >
          <FolderLock
            size={20}
            color="#198754"
            strokeWidth={2}
            className="mx-1"
            onClick={(e) => {
              setshowBrokerModal(true);
              setshowBrokerDetails(row);
            }}
          />
        </span>
      ),
      ignoreRowClick: true,
      button: true,
    },
    {
      name: "Permission",
      cell: (row) => (
        <span title="Sidebar Permission">
          <FolderLock
            size={20}
            color="#198754"
            strokeWidth={2}
            className="mx-1"
            onClick={() => {
              setshowPanelName({
                rowdata: row,
                panel_name: row.panel_name,
                id: row._id,
                db_url: row.db_url,
                db_name: row.db_name,
                key: row.key,
              });
              setshowModal(true);
            }}
            style={{ cursor: "pointer" }}
          />
        </span>
      ),
      ignoreRowClick: true,
      button: true,
    },
    {
      name: "Licence Details",
      cell: (row) => (
        <span title="Panel Views">
          <FileClock
            size={20}
            color="#198754"
            strokeWidth={2}
            onClick={() => Panel_Info(row)}
            className="mx-1"
            style={{ cursor: "pointer" }}
          />
        </span>
      ),
      ignoreRowClick: true,
      button: true,
    },
    {
      name: "History",
      cell: (row) => (
        <span title="Panel Views">
          <FileClock
            size={20}
            color="#198754"
            strokeWidth={2}
            onClick={() => Panel_History(row)}
            className="mx-1"
            style={{ cursor: "pointer" }}
          />
        </span>
      ),
      ignoreRowClick: true,
      button: true,
    },
    {
      name: "Clients",
      cell: (row) => (
        <span title="Panel Views" onClick={() => setLocalStorage(row)}>
          <Link to={`/super/showclient`} state={row}>
            <Users2
              size={20}
              color="#198754"
              strokeWidth={2}
              className="mx-1"
              style={{ cursor: "pointer" }}
            />
          </Link>
        </span>
      ),
      ignoreRowClick: true,
      button: true,
    },
    {
      name: "Subadmins",
      cell: (row) => (
        <span title="Panel Views">
          <Link to="/super/subadminlist" state={row}>
            <Users2
              size={20}
              color="#198754"
              strokeWidth={2}
              className="mx-1"
              style={{ cursor: "pointer" }}
            />
          </Link>
        </span>
      ),
      ignoreRowClick: true,
      button: true,
    },
    {
      name: "Add Licence",
      cell: (row) => (
        <span title="Add Licence">
          <Plus
            size={20}
            color="#198754"
            strokeWidth={2}
            className="mx-1"
            onClick={() => {
              setshowPanelName({
                panel_name: row.panel_name,
                id: row._id,
                db_url: row.db_url,
                db_name: row.db_name,
                key: row.key,
              });
              setshowAddLicenceModal(true);
            }}
            style={{ cursor: "pointer" }}
          />
        </span>
      ),
      ignoreRowClick: true,
      button: true,
    },

    {
      name: "Signal",
      cell: (row) => (
        <span title="HelpingHand" onClick={() => handleLocalStorage(row)}>
          <Link to="/super/signals" state={row}>
            <RadioTower
              size={20}
              color="#198754"
              strokeWidth={2}
              className="mx-1"
              style={{ cursor: "pointer" }}
            />
          </Link>
        </span>
      ),
      ignoreRowClick: true,
      button: true,
    },
  ];

  const columns1 = [
    {
      name: "Panel Name",
      selector: (row) => row.panal_name,
      cell: (row) => (
        <span title="Panel Views">
          <Link
            to={`${row.domain}/#/login`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none", // removes underline
              filter: "blur(0)", // ensures no blur
            }}
          >
            {row.panal_name}
          </Link>
        </span>
      ),
      sortable: true,
    },

    {
      name: "Super Admin Name",
      selector: (row) => row.superadmin_name,
      cell: (row) => <span title="Panel Views">{row.superadmin_name}</span>,
      sortable: true,
    },

    {
      name: "Client Id",
      selector: (row) => row.client_id,
      cell: (row) => <span title="Panel Views">{row.client_id}</span>,
      sortable: true,
    },
    {
      name: "Message",
      selector: (row) => row.msg,
      cell: (row) => <span title="Panel Views">{row.msg}</span>,
      sortable: true,
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <span title="Created At">
          {new Date(row.createdAt).toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,   // <-- 24-hour format
          })}
        </span>
      ),
      sortable: true,
    },

  ];

  useEffect(() => {
    if (panelData1 && panelData1.data) {
      const filterData =
        panelData1.data &&
        panelData1.data.filter((item) => {
          const matchSearch =
            searchInput === "" ||
            item.panel_name.toLowerCase().includes(searchInput.toLowerCase());

          return matchSearch;
        });
      setPanelData({
        loading: false,
        data: filterData,
      });
    } else {
      setPanelData({
        loading: false,
        data: [],
      });
    }
  }, [searchInput]);

  useEffect(() => {
    localStorage.removeItem("RowData");
    localStorage.removeItem("backend_rul");
    data();
    
  }, [refresh]);

  return (
    <>
      <Content Page_title="Admin Permission" button_status={false}>
        <div className="d-flex">
          <div className="mb-4 me-2">
            <h6>Search here something</h6>
            <input
              type="text"
              style={{ height: "2rem" }}
              placeholder="search..."
              className="p-2 rounded"
              onChange={(e) => {
                setSearchInput(e.target.value);
              }}
              value={searchInput}
            />
          </div>
          <div className="mt-4 ">
            <button
              className="btn btn-sm btn-primary p-2 "
              onClick={() => setRefresh((prev) => !prev)}
            >
              <i className="fa fa-refresh"></i>
            </button>
          </div>
        </div>

        {panelData?.loading ? (
          <Loader />
        ) : (
          <Table columns={columns} data={panelData?.data} />
        )}

        {HistoryStatus && (
          <div>
            <Modal
              isOpen={true}
              size="xl"
              title="History"
              hideBtn={true}
              handleClose={() => SetHistoryStatus(false)}
            >
              <Table columns={columns1} data={filteredData1} />
            </Modal>
          </div>
        )}

        <SidebarPermission
          showPanelName={showPanelName}
          showModal={showModal}
          setshowModal={() => setshowModal(false)}
          refresh={refresh}
          setRefresh={setRefresh}
        />
        <BrokerPermittion
          List={showBrokerDetails}
          showModal={showBrokerModal}
          permission={showBrokerDetails}
          setshowModal={() => setshowBrokerModal(false)}
          refresh={refresh}
          setRefresh={setRefresh}
        />

        <AddLicence
          showPanelName={showPanelName}
          showModal={showAddLicenceModal}
          setshowModal={() => setshowAddLicenceModal(false)}
        />

        <Adjust_Month
          showPanelName={showPanelName}
          showModal={showAdjustMonthModal}
          setshowModal={() => setshowAdjustMonthModal(false)}
        />

        {showLicenceModal && (
          <LicenceDetails
            id={showLicenceDetails}
            showModal={showLicenceModal}
            setshowModal={() => setshowLicenceModal(false)}
          />
        )}
        <ToastButton />
      </Content>
    </>
  );
};

export default AllPermitions;
